import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { added, edited } from "../features/jobs/jobsSlice";

export default function Form({ editmode }) {
  const titleRef = useRef();
  const typeRef = useRef();
  const salaryRef = useRef();
  const deadlineRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { jobs } = useSelector((state) => state.jobs);
  const { jobOnEdit } = useSelector((state) => state.jobOnEdit);

  const { id, title, type, salary, deadline } = jobOnEdit;

  useEffect(() => {
    if (editmode) {
      titleRef.current.value = title;
      typeRef.current.value = type;
      salaryRef.current.value = salary;
      deadlineRef.current.value = deadline;
    }
  });

  const getmaxId = () => {
    jobs.reduce((prevId, currentJob) => {
      return Math.max(prevId, currentJob.id);
    }, -1);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (editmode) {
      const data = {
        id: id,
        title: titleRef.current.value,
        type: typeRef.current.value,
        salary: salaryRef.current.value,
        deadline: deadlineRef.current.value,
      };
      dispatch(edited(data));
    } else {
      const data = {
        id: getmaxId() + 1,
        title: titleRef.current.value,
        type: typeRef.current.value,
        salary: salaryRef.current.value,
        deadline: deadlineRef.current.value,
      };
      dispatch(added(data));
    }
    navigate("/");
  };

  return (
    <>
      <h1 className="mb-10 text-center section-title">
        {editmode ? "Edit the job" : "Add New Job"}
      </h1>

      <div className="max-w-3xl mx-auto">
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div className="fieldContainer">
            <label
              htmlFor="lwsJobTitle"
              className="text-sm font-medium text-slate-300"
            >
              Job Title
            </label>
            <select
              ref={titleRef}
              id="lwsJobTitle"
              name="lwsJobTitle"
              autoComplete="lwsJobTitle"
              required
              defaultValue=""
            >
              <option value="" hidden>
                Select Job
              </option>
              <option value="Software Engineer">Software Engineer</option>
              <option value="Software Developer">Software Developer</option>
              <option value="Full Stack Developer">Full Stack Developer</option>
              <option value="MERN Stack Developer">MERN Stack Developer</option>
              <option value="DevOps Engineer">DevOps Engineer</option>
              <option value="QA Engineer">QA Engineer</option>
              <option value="Product Manager">Product Manager</option>
              <option value="Social Media Manager">Social Media Manager</option>
              <option value="Senior Executive">Senior Executive</option>
              <option value="Junior Executive">Junior Executive</option>
              <option value="Android App Developer">
                Android App Developer
              </option>
              <option value="IOS App Developer">IOS App Developer</option>
              <option value="Frontend Developer">Frontend Developer</option>
              <option value="Frontend Engineer">Frontend Engineer</option>
            </select>
          </div>
          <div className="fieldContainer">
            <label htmlFor="lwsJobType">Job Type</label>
            <select
              ref={typeRef}
              id="lwsJobType"
              name="lwsJobType"
              autoComplete="lwsJobType"
              required
              defaultValue=""
            >
              <option value="" hidden>
                Select Job Type
              </option>
              <option value="Full Time">Full Time</option>
              <option value="Internship">Internship</option>
              <option value="Remote">Remote</option>
            </select>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lwsJobSalary">Salary</label>
            <div className="flex border rounded-md shadow-sm border-slate-600">
              <span className="input-tag">BDT</span>
              <input
                ref={salaryRef}
                type="number"
                name="lwsJobSalary"
                id="lwsJobSalary"
                required
                className="!rounded-l-none !border-0"
                placeholder="20,00,000"
              />
            </div>
          </div>

          <div className="fieldContainer">
            <label htmlFor="lwsJobDeadline">Deadline</label>
            <input
              ref={deadlineRef}
              type="date"
              name="lwsJobDeadline"
              id="lwsJobDeadline"
              required
            />
          </div>
          <div className="text-right">
            <input
              type="submit"
              value={editmode ? "Update" : "Save"}
              className="lws-submit cursor-pointer btn btn-primary w-fit"
            />
          </div>
        </form>
      </div>
    </>
  );
}
